import { Stack, Icon, Persona, IPersonaProps, TooltipHost, DirectionalHint } from '@fluentui/react';
import React from 'react';
import * as Api from '../api/src'

export const Avatar = ({ keyColor, imageInitials, text, secondaryText, size,
  presence, imageAlt, color, showSecondaryText, RandomColor, hidePersonaDetails, directionalHint, IsShowTooltip }: IPersonaProps &
  { keyColor?: string, RandomColor: boolean, directionalHint?: DirectionalHint, IsShowTooltip?: boolean }) => {
  const Colors = [
    "#E74856", "#0078D7", "#0099BC", "#7A7574", "#767676",
    "#FF8C00", "#E81123", "#0063B1", "#2D7D9A", "#5D5A58", "#4C4A48",
    "#F7630C", "#EA005E", "#8E8CD8", "#00B7C3", "#68768A", "#69797E",
    "#CA5010", "#C30052", "#6B69D6", "#038387", "#515C6B", "#4A5459",
    "#DA3B01", "#E3008C", "#8764B8", "#00B294", "#567C73", "#647C64",
    "#EF6950", "#BF0077", "#744DA9", "#018574", "#486860", "#525E54",
    "#D13438", "#C239B3", "#B146C2", "#00CC6A", "#498205", "#847545",
    "#FF4343", "#9A0089", "#881798", "#10893E", "#107C10", "#7E735F",];
  function _stringAsciiPRNG(value: string, m: number) {
    // Xn+1 = (a * Xn + c) % m
    // 0 < a < m
    // 0 <= c < m
    // 0 <= X0 < m
    if (!value) return 0;
    const charCodes = [...value].map(letter => letter.charCodeAt(0));
    const len = charCodes.length;
    const a = (len % (m - 1)) + 1;
    const c = charCodes.reduce((current, next) => current + next) % m;
    let random = charCodes[0] % m;
    for (let i = 0; i < len; i++)
      random = ((a * random) + c) % m;
    return random;
  }

  return (
    <TooltipHost content={IsShowTooltip ? text : ""} directionalHint={directionalHint} >
        <Persona
          imageInitials={imageInitials}
          text={text}
          secondaryText={secondaryText}
          size={size}
          presence={presence}
          imageAlt={imageAlt}
          hidePersonaDetails={hidePersonaDetails}
          initialsColor={RandomColor ? Colors[_stringAsciiPRNG(keyColor || "", 47)] : color}
          showSecondaryText={showSecondaryText}
          styles={{secondaryText: {color: color}}}
        />
    </TooltipHost>

  );
};
